// Ketch Data Privacy - Consent Link Handler
(function() {
  function revealConsentLinks() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', revealConsentLinks);
      return;
    }

    document.querySelectorAll('.consent-link').forEach(function(el) {
      el.classList.add('is-visible');
    });
  }

  // 1. Initialize queue wrapper in case App Embed loads after
  window.semaphore = window.semaphore || [];
  window.ketch = window.ketch || function() { window.semaphore.push(arguments); };

  // 2. Register standard Ketch event listeners
  window.ketch('on', 'config', revealConsentLinks);
  window.ketch('on', 'consent', revealConsentLinks);
  window.ketch('on', 'environment', revealConsentLinks);

  // 3. Immediate check if Ketch/Lanyard DOM elements already exist
  if (document.querySelector('#lanyard_root') || document.querySelector('#lanyard_fab_button')) {
    revealConsentLinks();
  }

  // 4. Fallback Polling (catches missed events from App Embed load order)
  var attempts = 0;
  var pollKetch = setInterval(function() {
    attempts++;
    var isKetchReady = document.querySelector('#lanyard_root') || 
                       document.querySelector('#lanyard_fab_button') ||
                       (typeof window.ketch === 'function' && window.ketch.hasJurisdiction);

    if (isKetchReady) {
      revealConsentLinks();
      clearInterval(pollKetch);
    }

    // Stop checking after 6 seconds
    if (attempts >= 20) {
      clearInterval(pollKetch);
    }
  }, 300);
})();